import { configureStore, createSlice } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { themeApi } from "../services/themeApi";

const globalLoaderSlice = createSlice({
    name: "globalLoader",
    initialState: {
        isHeaderLoaded: false,
        isFooterLoaded: false,
    },
    reducers: {
        setHeaderLoaded: (state) => {
            state.isHeaderLoaded = true;
        },
        setFooterLoaded: (state) => {
            state.isFooterLoaded = true;
        },
    },
});

export const { setHeaderLoaded, setFooterLoaded } = globalLoaderSlice.actions;

// Selektor globalnego stanu ładowania
export const selectIsLoading = (state) =>
    !(state.globalLoader.isHeaderLoaded && state.globalLoader.isFooterLoaded);

export const store = configureStore({
    reducer: {
        [themeApi.reducerPath]: themeApi.reducer,
        globalLoader: globalLoaderSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(themeApi.middleware),
});

setupListeners(store.dispatch);
